import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CriterionsTemplateModel } from 'src/app/core/template';

@Component({
  selector: 'kt-criterions-template-modal',
  templateUrl: './criterions-template-modal.component.html',
  styleUrls: ['./criterions-template-modal.component.scss']
})
export class CriterionsTemplateModalComponent implements OnInit {
  public template: CriterionsTemplateModel;
  constructor(
    private dialogRef: MatDialogRef<CriterionsTemplateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.template = data.template;
  }

  ngOnInit(): void {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
